export default "__VITE_ASSET__C8ahgoe4__"